// Utilities
import { make } from 'vuex-pathify'

// Globals
import { IN_BROWSER } from '../../util/globals'

const state = {
  dark: false,
  drawer: {
    image: 0,
    gradient: 0,
    mini: false,
  },
  color:{
    primary:'#339999',
    secondary: "#9C27b0",
    accent: "#339999",
  },
  gradients: [
    'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)',
    'rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)',
    'rgba(244, 67, 54, .8), rgba(244, 67, 54, .8)',
  ],
  images: [
    /* 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-2.jpg',
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-3.jpg',
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-4.jpg', */
  ],
  notifications: [],
  rtl: true,
  // token:localStorage.getItem('token')
  currentThem:JSON.parse(localStorage.getItem('borka@user'))
}

const mutations = make.mutations(state)

const actions = {
  fetch: ({commit,state}) => {
    const local = localStorage.getItem('borka@user') || '{}'
    const user = JSON.parse(local)
    for (const key in user) {
      commit(key, user[key])
    }

    if (user.dark === undefined) {
      commit('dark', false)
    }
    
  },
  update: ({ dispatch,state }) => {
    if (!IN_BROWSER) return
    localStorage.setItem('borka@user', JSON.stringify(state))
    
  },
  init: async ({ dispatch ,state}) => {
    dispatch('fetch');
  },
}

const getters = {
  dark: (state, getters) => {
    return (
      state.dark ||
      getters.gradient.indexOf('255, 255, 255') === -1
    )
  },
  gradient: state => {
    return state.gradients[state.drawer.gradient]
  },
  image: state => {
    return state.drawer.image === '' ? state.drawer.image : state.images[state.drawer.image]
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
